<template>
  <page-header-wrapper>
    <div slot="extra">
      <router-link v-action:add :to="{ path: '/settings/articles/form' }">
        <a-button type="primary" icon="plus">创建文章</a-button>
      </router-link>
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.title"
              placeholder="请输入名称"
              enter-button
              @search="getLists()"
            />
            <a-button type="link" @click="() => (this.search = !this.search)">
              高级筛选
              <a-icon :type="search ? 'up' : 'down'" />
            </a-button>
          </div>
        </standard-form-row>
        <template v-if="search">
          <standard-form-row title="所属分类" block style="padding-bottom: 11px;">
            <a-form-item>
              <a-spin tip="Loading..." :spinning="selectLoading">
                <tag-select
                  v-model="params.where.place"
                  @change="getLists()"
                >
                  <tag-select-option :value="index" :key="index" v-for="(key, index) in selectList">{{
                    key
                  }}</tag-select-option>
                </tag-select>
              </a-spin>
            </a-form-item>
          </standard-form-row>
          <standard-form-row title="日期" block>
            <a-form-item :wrapper-col="{ sm: { span: 8 }, xs: { span: 24 } }">
              <a-range-picker
                :ranges="{
                  最近七天: [moment().subtract('days', 6), moment()],
                  今天: [moment(), moment()],
                  本月: [moment().startOf('month'), moment()]
                }"
                :placeholder="['开始日期', '结束日期']"
                @change="values => handleChangeDate(values)"
              />
            </a-form-item>
          </standard-form-row>
          <standard-form-row title="排序" grid>
            <a-row>
              <a-col :lg="20" :md="20" :sm="24" :xs="24">
                <a-form-item :wrapper-col="{ sm: { span: 20 }, xs: { span: 24 } }">
                  <a-radio-group v-model="orderID" @change="handleChangeOrder">
                    <a-radio-button value="id">ID</a-radio-button>
                    <a-radio-button value="order">排序</a-radio-button>
                    <a-radio-button value="created_at">创建时间</a-radio-button>
                    <a-radio-button value="updated_at">修改时间</a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :lg="4" :md="4" :sm="24" :xs="24">
                <a-form-item :wrapper-col="{ sm: { span: 24 }, xs: { span: 24 } }">
                  <a-select
                    placeholder="不限"
                    v-model="orderVal"
                    style="width: 120px"
                    @change="handleChangeOrder"
                  >
                    <a-select-option value="asc">升序</a-select-option>
                    <a-select-option value="desc">降序</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </standard-form-row>
        </template>
      </a-form>
    </a-card>
    <a-card style="margin-top: 24px;" :bordered="false" title="文章列表">
      <div slot="extra" class="change-state">
        <a-radio-group @change="searchChangeState">
          <a-radio-button value="0">全部</a-radio-button>
          <a-radio-button value="1">展示</a-radio-button>
          <a-radio-button value="2">隐藏</a-radio-button>
        </a-radio-group>

      </div>
      <a-list size="default" :loading="loading" :pagination="pagination">
        <a-list-item :key="index" v-for="(item, index) in list">
          <a-list-item-meta>
            <h3 slot="title" :title="item.title">{{ item.title }}</h3>
            <template slot="description">
              <div class="list-items">
                <span>
                  创建时间：
                  <a-tag color="pink">{{ moment(item.created_at).fromNow() }}</a-tag>
                </span>
                <span>
                  上次更新时间：
                  <a-tag color="green">{{ moment(item.updated_at).fromNow() }}</a-tag>
                </span>
              </div>
              <div class="list-items">
                <span>排序：</span>
                <span style="color:red;font-weight:700">{{ item.order }}</span>
              </div>
              <div class="list-items" v-if="item.keyword">
                <a-tag v-for="(keyword, key) in (item.keyword || '').split(',')" :key="key">
                  {{ keyword }}
                </a-tag>
              </div>

            </template>
          </a-list-item-meta>

          <div class="list-content" v-action:state>
            <div class="list-content-item">
              <span>状态：</span>
              <span>
                <a-switch :checked="item.state === 1" @change="handleChangeState(item.id)">
                  <a-icon slot="checkedChildren" type="check" />
                  <a-icon slot="unCheckedChildren" type="close" />
                </a-switch>
              </span>
            </div>
          </div>
          <div slot="actions">
            <router-link v-action:update :to="'/settings/articles/form/' + item.id">
              <a>编辑</a>
            </router-link>
          </div>
          <div slot="actions">
            <a-popconfirm
              title="确定要删除该文章吗？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleOnDelete(item.id)"
              v-action:delete
            >
              <a href="#">删除</a>
            </a-popconfirm>
          </div>
        </a-list-item>
      </a-list>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, select, card } from '@/mixins' // 引入
import { TagSelect, StandardFormRow } from '@/components'

const TagSelectOption = TagSelect.Option
const apiList = {
    getList: '/settings/articles',
    delete: '/settings/articles/',
    selectList: '/settings/articles/place',
    changeState: '/settings/articles/'
}
export default {
    name: 'ArticleList',
    mixins: [list, select, card], // 使用mixins
    components: {
        TagSelect,
        TagSelectOption,
        StandardFormRow
    },
    data () {
        return {
            apiList,
            selectList: [],
            selectLoading: false
        }
    },
    mounted () {
        this.getLists() // 获取列表
        this.getSelectLists({
            url: apiList.selectList
        }) // 获取分类下拉
    },
    methods: {

    }
}
</script>
